import React from 'react'
import ier_logo from '../../assets/images/icons/ier-logo2.png'
import {Link, useLocation} from 'react-router-dom'
import classNames from 'classnames';
import { MdEmail, MdCall } from "react-icons/md"

const LandingTopHeader = (props)=>{

    const location = useLocation()
    const {pathname} = location

    var finalPathName= pathname.split('/')[1]

    return(
        <div className="landing-topbar-container">
            <div className="logo-image-contanier">
                <img src={ier_logo}/>
                <div>
                    <p>INSTITUTION OF ENGINEERS RWANDA</p>
                </div>
            </div>
                <div className="nav-link-contanier">
                    <div className='nav-socials-container'>
                        <span className='nav-socials'>
                           <MdCall style={{ fontSize: "25px"}}/>
                           <p>(+250) 789 904 228</p>
                        </span>
                        <span className='nav-socials'>
                           <MdEmail style={{ fontSize: "25px"}}/>
                            <p>info@engineersrwanda.rw</p>
                        </span>
                        <a style={{
                            textDecoration: 'none'}}
                            href="https://engineersrwanda.rw/ier-home"
                            target="__blank"
                            className={classNames("landing-membership-nav", {'landing-active':finalPathName === 'home'})}
                            >
                            <span style={{ color: "#0d6efd", fontWeight: "500", fontSize: "16px"}}>Home</span>
                        </a>
                    </div>
                    {/* <div style={{width: '50%'}}></div> */}
                </div>
        </div>
    )

}


export default LandingTopHeader

